

export const accountsTypesHM = new Map([
    ["Sync_Customer","Official"],
    ["Prospect_Account","Prospect"],
    ["Partner","Partner"]
]);

export const backgroundColorAccounts = new Map([
    ["Sync_Customer", "#E7F5E6"],
    ["Prospect_Account", "#F2EBFE"],
    ["Partner", "#DCEEFB"]
]);

export const fontColorAccounts = new Map([
    ["Sync_Customer", "#4C9E3A"],
    ["Prospect_Account", "#690CB0"],
    ["Partner", "#0F609B"]
]);



